import axios from 'axios'
export default {
    namespaced: true,
    state: {
		name: 'FleetObjectEstimateType',
		endpoint: '/fleet/object/estimate/type',
		icon: 'mdi-car-2-plus',
		item: {},
        items: [],
    },
    actions: {
		load (context) {
			return axios.get(context.getters.endpoint).then(response => {
				context.commit('items', response.data)
			}, error => { console.log(error); })
		},
    }
}